/**
 * react-intl v2 logs console.error on every missing id. Custom pipeline stage names
 * (e.g. "Triagem Cognitiva") were formatted as Pipeline.<name> hundreds of times per
 * render and froze the main thread.
 */

export function hasIntlMessage(intl, id) {
  if (!id || !intl) return false;

  const messages = intl.messages;
  return !!(messages && Object.prototype.hasOwnProperty.call(messages, id));
}

export function formatIntlMessage(intl, id, defaultMessage) {
  if (!intl || !id) return defaultMessage || '';
  if (hasIntlMessage(intl, id)) {
    return intl.formatMessage({ id, defaultMessage: defaultMessage || id });
  }

  return defaultMessage != null ? defaultMessage : id;
}

/** Label for a pipeline stage without spamming Missing message errors. */
export function formatPipelineStageName(intl, stage) {
  if (!stage) return '';

  const rawName = stage.name || '';
  const trimmed = String(rawName).trim();
  if (trimmed.toUpperCase() === 'ENTREVIST.AI') {
    return formatIntlMessage(intl, 'CardVideoInterview.title', 'ENTREVIST.AI');
  }

  if (trimmed.startsWith('type_') && stage.type) {
    return formatIntlMessage(intl, 'Pipeline.type_' + String(stage.type).toLowerCase(), trimmed);
  }

  const byName = formatIntlMessage(intl, 'Pipeline.' + trimmed.toLowerCase(), null);
  if (byName && byName !== 'Pipeline.' + trimmed.toLowerCase()) {
    return byName;
  }

  return rawName || trimmed;
}
